import { Box, Button, HStack, Text, VStack } from '@chakra-ui/react'
import { format } from 'date-fns'
import React, { useCallback, useState } from 'react'
import { REPOSITORY } from '../../../../api/repository/Repository'
import CustomDatePicker from '../../../../components/CustomDatePicker/CustomDatePicker'
import { useRequestStatusContext } from './../../../../utils/hooks/Context/RequestStatusContext'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import PartnersBalanceReport from './PartnersBalanceReport'

export default function PartnersBalance() {
  const [data, setData] = useState(null)
  const [filterData, setFilterData] = useState({})
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()
  const handleGetNNData = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .recargaColaboradoresReporte(filterData.dDesde, filterData.dHasta)
      .then((res) => setData(res.data))
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle(error.response.data.error, error.response.status)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
    handleCLoseLoading()
  }

  const handleGetReport = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .recargaColaboradoresExport(filterData.dDesde, filterData.dHasta)
      .then((res) => {
        handleCLoseLoading()
        const url = URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Partners_balance.xlsx`)
        document.body.appendChild(link)
        link.click()
        handleSetTitle('Reporte descargado con exito', 200)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            Continuar
          </Button>,
        )
        handleOpen()
        handleCLoseLoading()
      })
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle('No se pudo exportar el reporte.', error.response.status)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
  }

  const handleChangeFrom = useCallback((date) => {
    setFilterData((prevState) => ({
      ...prevState,
      dDesde: date ? format(date, 'dd-MM-yyyy') : null,
    }))
  }, [])
  const handleChangeTo = useCallback((date) => {
    setFilterData((prevState) => ({
      ...prevState,
      dHasta: date ? format(date, 'dd-MM-yyyy') : null,
    }))
  }, [])
  return (
    <VStack alignItems="flex-start">
      <HStack alignItems="flex-end">
        <VStack alignItems="flex-start" justifyContent="flex-start">
          <Text variant="subtitle2">Desde</Text>
          <Box
            maxW="150px"
            minW="150px"
            borderRadius={3}
            border="1px solid #D7D7D7"
          >
            <CustomDatePicker
              maxDate={new Date()}
              onChange={handleChangeFrom}
              placeholder="dd/mm/aaaa"
            />
          </Box>
        </VStack>
        <VStack alignItems="flex-start" justifyContent="flex-start">
          <Text variant="subtitle2">Hasta</Text>
          <Box
            maxW="150px"
            minW="150px"
            borderRadius={3}
            border="1px solid #D7D7D7"
          >
            <CustomDatePicker
              maxDate={new Date()}
              onChange={handleChangeTo}
              placeholder="dd/mm/aaaa"
            />
          </Box>
        </VStack>
        <VStack paddingStart={5}>
          <Button borderRadius={10} onClick={handleGetNNData}>
            Buscar
          </Button>
        </VStack>
      </HStack>
      {data && (
        <HStack alignItems="flex-end" paddingTop={10} paddingBottom={5}>
          <PartnersBalanceReport data={data} />
          <VStack paddingStart={5}>
            <Button
              borderRadius={8}
              variant="ghost"
              minHeight="56px"
              padding="0px 15px"
              backgroundColor="#fff"
              onClick={handleGetReport}
              border="1px solid #D7D7D7"
            >
              <Box me={3}>
                <FontAwesomeIcon icon={faDownload} />
              </Box>
              Descargar informe
            </Button>
          </VStack>
        </HStack>
      )}
    </VStack>
  )
}
